/* jshint esversion: 6 */
import Vue from 'vue';
import VueResource from 'vue-resource';
import App from './App';
import Router from './router';

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;

const app = new Vue({
  el: '#app',
  router: Router,
  render: h => h(App), // the render function to render the App component.
});
// .$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js